import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../actions/index';

class LogoutContainer extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.postLogoutRequest();
  }

  render() {
    return null;
  }
}

const mapStateToProps = () => ({});

LogoutContainer.propTypes = {
  postLogoutRequest: PropTypes.func,
};

export default withRouter(
  connect(mapStateToProps, {
    postLogoutRequest: actions.postLogoutRequest,
  })(LogoutContainer),
);
